import { useState } from 'react';
import './ChapterSelector.css';

const ChapterSelector = ({ 
  chapters, 
  currentChapter, 
  onChapterChange, 
  books 
}) => {
  const [selectedBook, setSelectedBook] = useState(currentChapter?.book || '');

  const handleBookChange = (e) => {
    const book = e.target.value;
    setSelectedBook(book);
    
    // Find the first chapter of the selected book
    const firstChapterOfBook = chapters.find(ch => ch.book === book);
    if (firstChapterOfBook) {
      onChapterChange(firstChapterOfBook.id);
    }
  };

  const handleChapterChange = (e) => {
    const chapterId = e.target.value;
    onChapterChange(chapterId);
  };

  // Get chapters for the selected book
  const getChaptersForSelectedBook = () => {
    return chapters.filter(ch => ch.book === selectedBook);
  };

  // Update selected book when current chapter changes
  if (currentChapter && selectedBook !== currentChapter.book) {
    setSelectedBook(currentChapter.book);
  }

  return (
    <div className="chapter-selector">
      <div className="selector-group">
        <label htmlFor="book-select">Book:</label>
        <select
          id="book-select"
          value={selectedBook}
          onChange={handleBookChange}
          className="book-selector"
        >
          <option value="">Select a book...</option>
          {books.map(book => (
            <option key={book} value={book}>
              {book}
            </option>
          ))}
        </select>
      </div>

      <div className="selector-group">
        <label htmlFor="chapter-select">Chapter:</label>
        <select
          id="chapter-select"
          value={currentChapter?.id || ''}
          onChange={handleChapterChange}
          className="chapter-selector-dropdown"
          disabled={!selectedBook}
        >
          <option value="">Select chapter...</option>
          {getChaptersForSelectedBook().map(chapter => (
            <option key={chapter.id} value={chapter.id}>
              Chapter {chapter.chapter}
            </option>
          ))}
        </select>
      </div>

      {currentChapter && (
        <div className="current-selection">
          <span className="current-chapter-info">
            <strong>{currentChapter.book} {currentChapter.chapter}</strong>
            <span className="chapter-meta">
              ({currentChapter.testament} Testament • {currentChapter.verseCount} verses)
            </span>
          </span>
        </div>
      )}
    </div>
  );
};

export default ChapterSelector;
